import { type Route } from '#app/routes/mocra+/_sections+/+types/605.ts'
import { SECTIONS } from '#app/routes/mocra+/_sections+/section-data.ts'
import { SectionDetail } from '#app/routes/mocra+/_sections+/section-detail.tsx'

export const meta: Route.MetaFunction = () => [
	{ title: 'MoCRA — §605 Serious Adverse Event Reporting' },
]

export default function Section605() {
	return <SectionDetail section={SECTIONS['605']} />
}
